import React from 'react';
import { fx } from '../../fx.js';
import { ink } from '../../primitives.js';

const h = React.createElement;

const TINT = { none: 'var(--card)', gold: 'var(--gold)', lime: 'var(--lime)', coral: 'var(--coral)', paper: 'var(--paper)' };

const GHOST = { none: ['var(--lime)', 'var(--coral)'], paper: ['var(--lime)', 'var(--coral)'], lime: ['var(--gold)', 'var(--coral)'], gold: ['var(--lime)', 'var(--coral)'], coral: ['var(--lime)', 'var(--gold)'] };

/**
 * The drawn card: 2px ink border, hard offset shadow. `compact` for nested cards; `tint` is a
 * headline (one per row). Replaces CompactCard.
 *
 * @param {object} p
 * @param {boolean} [p.hover]
 * @param {boolean} [p.tilt]
 * @param {React.ReactNode} [p.children]
 * @param {boolean} [p.compact]
 * @param {'none'|'lime'|'gold'|'coral'|'paper'} [p.tint]
 * @param {React.MouseEventHandler} [p.onClick]
 * @param {string} [p.title]
 * @param {React.CSSProperties} [p.style]
 * @param {string} [p.as]
 */
export function Card({ children, compact, tint = 'none', onClick, title, style, as = 'div', hover = true, tilt }) {
  const ref = React.useRef(null);
  const base = compact ? [3, 3] : [4, 5];
  const tiltMove = (e) => { const f = fx; if (!f.finePointer || !f.finePointer() || f.reduced()) return; const el = ref.current, r = el.getBoundingClientRect(); const px = (e.clientX - r.left) / r.width - .5, py = (e.clientY - r.top) / r.height - .5; el.style.transition = 'none'; el.style.transform = `perspective(700px) rotateX(${(-py * 9).toFixed(2)}deg) rotateY(${(px * 11).toFixed(2)}deg)`; el.style.boxShadow = `${(base[0] - px * 10).toFixed(1)}px ${(base[1] - py * 10).toFixed(1)}px 0 var(--ink)`; };
  const tiltLeave = () => { const el = ref.current; if (!el) return; el.style.transition = 'transform 420ms cubic-bezier(.34,1.56,.64,1), box-shadow 420ms cubic-bezier(.34,1.56,.64,1)'; el.style.transform = (style && style.transform) || ''; el.style.boxShadow = (style && style.boxShadow) || (compact ? 'var(--el-2)' : 'var(--el-3)'); };
  const g = GHOST[tint] || GHOST.none;
  return h(as, {
    ref, onClick, title, className: [onClick ? 'mo-lift' : '', hover ? 'gx-card' : ''].join(' ').trim() || undefined, role: onClick ? 'button' : undefined, tabIndex: onClick ? 0 : undefined,
    onPointerMove: tilt ? tiltMove : undefined, onPointerLeave: tilt ? tiltLeave : undefined,
    style: { '--gx-a': g[0], '--gx-b': g[1], position: 'relative', background: TINT[tint] || TINT.none, color: tint === 'none' || tint === 'paper' ? 'var(--tx)' : 'var(--on-accent)', border: ink(2), borderRadius: compact ? 'var(--r-card-sm)' : 'var(--r-card)', boxShadow: compact ? 'var(--el-2)' : 'var(--el-3)', padding: compact ? 'var(--card-pad-sm)' : 'var(--card-pad)', boxSizing: 'border-box', cursor: onClick ? 'pointer' : undefined, ...style }
  }, children);
}
